import React, { useEffect, useState } from 'react'

import Link from '@components/link'
import styles from '@components/blocks/subnavigation.module.scss'

const Subnavigation = React.forwardRef(({ fields }, _) => {
  const [pathname, setPathname] = useState(null)
  const menuItems = fields.menuItems

  useEffect(() => {
    if (window && window.location) {
      setPathname(window.location.pathname)
    }
  }, [])

  return (
    <div className={styles.subnavigation__container}>
      {menuItems.map(item => {
        const path = item.fields.path

        return (
          <Link
            key={item.id}
            path={path}
            className={
              pathname && pathname.includes(path.fields.path)
                ? styles['subnavigation__item--active']
                : styles.subnavigation__item
            }
          >
            {item.fields.name}
          </Link>
        )
      })}
    </div>
  )
})

export default Subnavigation
